const getRoleResponse = (response) => {
  const totalData = response?.totalData ?? 0;
  const totalPage = response?.totalPage ?? 0;
  const isDataExist = response?.isDataExist;

  const roles = response?.roles?.map((item) => {
    const permissions = [];

    const menus = item?.menus?.map((menu) => {
      return {
        id: menu?.id,
        name: menu?.name,
        path: menu?.path,
        permissions: menu?.permissions?.map((permission) => {
          return {
            id: permission?.id,
            name: permission?.name,
            attribute: permission?.attribute,
            order: permission?.order,
          };
        }),
      };
    });

    item?.menus?.forEach((menu) => {
      menu?.permissions?.forEach((permission) => {
        permissions.push(permission?.name);
      });
    });

    return {
      id: item?.id,
      name: item?.name,
      isHost: item?.isHost,
      isOperator: item?.isOperator,
      isBackoffice: item?.isBackoffice,
      menus,
      permissions,
    };
  });

  return { roles, totalData, totalPage, isDataExist };
};

export default getRoleResponse;
